// extracted by mini-css-extract-plugin
module.exports = {"nav":"Secondary_nav__Ne9PC","title":"Secondary_title__VYP5f"};